const socials = [
  { label: "INSTAGRAM", testId: "footer-social-instagram", href: "https://www.instagram.com/made.by.bite" },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="flex flex-col items-center justify-between gap-6 border-t border-white/10 px-6 py-10 md:flex-row md:px-10"
    >
      <span
        data-testid="footer-copyright"
        className="font-mono text-[10px] tracking-[0.3em] text-zinc-600"
      >
        © 2026 BITE — AI ADVERTISING & FULL PRODUCTION STUDIO
      </span>
      <div className="flex items-center gap-8">
        {socials.map((social) => (
          <a
            key={social.label}
            href={social.href}
            target={social.href.startsWith("http") ? "_blank" : undefined}
            rel={social.href.startsWith("http") ? "noopener noreferrer" : undefined}
            data-testid={social.testId}
            className="group relative font-mono text-[10px] tracking-[0.3em] text-zinc-500 transition-colors duration-300 hover:text-[#E1A730]"
          >
            {social.label}
            <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#E1A730] transition-[width] duration-300 group-hover:w-full" />
          </a>
        ))}
      </div>
    </footer>
  );
}
